export default {
  unknown: 'Inconnu',
  attachmentsToSend: 'Pièces jointes à envoyer avec message',

  labels: {
    patient: 'Patient',
    viewTracker: 'Voir le traqueur',
    tac: 'Termes et conditions',
    faq: 'FAQs',
    writeReply: 'Rédiger une réponse',
    translate: 'Traduire',
    chooseDate: 'Choisir une date',
    copyWithinGroup: 'Copier au sein du groupe',
    selectDestination: 'Sélectionner une destination',
    group: 'Groupe',
    subgroup: 'Sous-groupe',
    beta: 'Cette section du rapport est encore en construction',
    startDate: 'Date de début',
    endDate: 'Date de fin',
    searchFaqs: 'Rechercher des FAQs',
  },

  emoji: {
    people: 'Gens',
    nature: 'La nature',
    places: 'Des endroits',
    objects: 'Objets',
    sybmols: 'Symboles',
  },

  validations: {
    signature: {
      required: 'Signature is required',
    },
    widget: {
      required: 'Widget is required',
    },
    option: {
      required: 'Please select an option',
    },
    dosage: {
      required: 'Dosage is required field',
    },
    unit: {
      required: 'Please select a unit',
    },
    systolic: {
      required: 'Systolic value is required',
    },
    diastolic: {
      required: 'Diastolic value is required',
    },
    address: {
      required: 'Address is required field',
    },
    zipCode: {
      required: 'Zip code is required field',
    },
    city: {
      required: 'City is required field',
    },
    state: {
      required: 'State is required field',
    },
    patient: {
      required: 'Please select a patient',
    },
    subject: {
      required: 'Please input a subject',
    },
    firstName: {
      required: 'Please input a first name',
    },
    lastName: {
      required: 'Please input a last name',
    },
    fullName: {
      required: 'Please input a full name',
      invalid: 'Please input a valid full name',
    },
    email: {
      required: 'Please input an email',
      invalid: 'Please input a valid email',
    },
    mobileNumber: {
      required: 'Please enter a phone number',
      invalid: 'Please enter a valid phone number',
      invalidCountryCode: 'Please enter a valid phone number with country code',
      notTextable: 'Number not Textable',
    },
    callerId: {
      required: 'Caller Id Required',
    },
    smsSubject: {
      required: 'Please input a subject',
    },
    number: 'Value must be a number',
    numberBetween: 'A value should be more than {min} and less than {max}',
    checkboxes: {
      requiredAll: 'You have to check all checkboxes',
      atLeastOne: 'You have to check at least one',
    },
    date: {
      required: 'Please select a date',
      yesterday: 'Yesterday',
      toray: 'Today',
    },
    time: {
      required: 'Please select a time',
    },
    text: {
      max: 'A value must not have more than {max} characters',
      min: 'A value must not have less than {min} characters',
    },
    file: {
      required: 'Please select a file',
      maxSize: 'File to big for upload (max size of {max}MB)',
    },
    required: 'Field is required',
    search: {
      atLeast: 'At least {count} characters',
    },
    name: {
      unique: 'The name should be unique',
    },
    frequency: {
      required: 'Doit spécifier',
      pickOne: 'Choisissez-en un',
    },
  },

  buttons: {
    submit: 'Soumettre',
    cancel: 'Annuler',
    yes: 'Oui',
    no: 'Non',
    clear: 'Dégager',
    delete: 'Effacer',
    agree: 'Accepter',
    disagree: 'Être en désaccord',
  },

  common: {
    loading: 'Loading...',
    noContent: 'No content',
    empty: 'Empty',
    httpError: 'Erreur inconnue. Veuillez réessayer plus tard.',
  },

  chat: {
    labels: {
      updatePatient: 'Update patient',
      noEmoji: 'There are no emojis with entered name',
      findConversation: 'Find conversation',
      findEmoji: 'Find emoji',
      reassign: 'Reassign',
      chat: 'Chat',
      startConversation: 'Start Conversation',
      waitingRoom: 'Waiting room',
      invitesSent: 'Invites sent',
      selectPatient: 'Select a patient',
      createPatient: 'Create new patient',
      onlyMyPatients: 'To search only your patients',
      myPatients: 'My patients',
      createPrivateConversation: 'To create a private conversation',
      privateConversation: 'Private conversation',
      textSubject: 'Text subject',
      emailSubject: 'Email subject',
      emailContent: 'Email body',
      mobileNumber: 'Mobile number',
      usCode: '+1',
      code: 'Code',
      status: 'Status',
      patientFullName: 'Patient First name and Last name',
      email: 'E-mail',
      mobile: 'Mobile',
      searchForPatient: 'Search for a patient or visitor',
      defaultSubject:
        '{firstName} {lastName} from {group} would like to start a secure conversation with you. Please click the link to accept.',
      markConversation: 'Mark this conversation as {label}?',
      assignConversation: 'Assign this conversation to {label}?',
      attachToMessage: 'Attach to message',
      saveAsTemplate: 'Save as Template',
      attachmentsToSend: 'Attachments to send with message',
      sendMessage: 'Send message',
      messagePreview: 'Message preview',
      invitationSent: 'Invitation sent to {message}',
      openConversationHeader: '{agentName} is conversing with the {personType}',
      waitingRoomHeader: '{botName} (Bot) is conversing with the {personType}',
      takeover: 'Takeover',
      blockTypingAlert:
        "This conversation is assigned to a bot. Takeover if you'd like to start the conversation.",
      blockTypingAlertAssign:
        "This conversation is assigned to {assignee}. You cannot reply unless it's assigned to you.",
      openedSubtab: 'Open conversations',
      widget: 'Widget',
      routine: 'Routine Follow-up',
      startVideoChatWarning: 'Would you like to start a Video Chat?',
      joinVideoChatWarning: 'Would you like to join a Video Chat?',
      startVoiceCallWarning: 'Would you like to start a Voice Call?',
      startCall: 'Start Call',
      startVoiceCall: 'Start a Voice Call',
      resendInvite: 'Resend Invite',
      resendInvitation: 'Resend invitation',
      editPatient: 'Edit patient',
      soloWarning: "Looks like you're the only one here!",
      interpreterDetails:
        '{name} will receive the following details at {email}:',
      facilityName: 'Facility Name',
      providerFirstName: 'Provider First Name',
      providerLastName: 'Provider Last Name',
      languageRequested: 'Language Requested',
      conversationLink: 'Conversation Link',
      patientEmailSubjectAlert:
        '{patient} will receive the above message followed by a link. When they click the link they will be redirected to a secure conversation with you.',
      selectInvintationSourse: 'Please select the invitation source',
      fillInRequiredFields: 'Please fill in all required fields',
      telephony: {
        callerIdHint:
          'The phone number that the patient will receive the call from',
        confirm:
          'Would you like to place a call from {callerId} to {phoneNumber}?',
        patientPhoneNumber: 'Patient Phone Number',
        providerCallerId: 'Provider Caller Id',
      },
    },

    messages: {
      success: {
        conversationCreate: 'A conversation has been created!',
        inviteResend: 'An invite has been successfully resent!',
        patientUpdate: 'Patient has been updated!',
      },

      warning: {
        deleteInvitation: 'Would you like to cancel the Invitation?',
      },

      error: {
        takeover: 'Failed to perform a takeover. Please try again later.',
        inviteResend: 'Failed to resend an invite. Please try again later.',
      },
    },

    audioTest: {
      userBrowser:
        "Version du navigateur sur la machine utilisateur du système d'exploitation utilisateur",
      skip: 'Sauter',
      testAgain: 'Testez à nouveau',
      viewTroubleShoot: 'Afficher les instructions de dépannage',
      instructions: 'Instructions de dépannage',
      testAudio: 'Testeur',
      didYouHear: 'Avez-vous entendu le son?',
      playAgain: 'Rejouer',
      start: 'TESTEZ VOTRE ÉQUIPEMENT',
      title: 'Test Audio / Caméra',
      unsupported: 'Non pris en charge',
      testMicrophone: 'Microphone de test',
      doYouSeeMic:
        'Voyez-vous une barre de progression bleue lorsque vous parlez?',
      testCamera: "Caméra d'essai",
      loading: 'Détection des appareils...',
      canYouSee: 'Pouvez-vous vous voir?',
      safariMessage:
        "Cette version du navigateur Safari a des problèmes avec l'audio. Apple a publié une mise à jour pour résoudre les problèmes audio. Veuillez mettre à jour votre iOS avec la dernière version.",
      instruction:
        'Nous testerons votre caméra, microphone et haut-parleur pour vous garantir la meilleure expérience de visite virtuelle.',
    },

    virtualBg: {
      title: "Choisissez l'arrière-plan",
      preview: 'Aperçu',
      backgrounds: 'Arrière-plans',

      names: {
        none: 'Rien',
        blur: 'Se brouiller',
        add: 'Ajouter une image',
      },

      actions: {
        apply: 'Appliquer',
      },
    },
  },

  quickForms: {
    labels: {
      zip: 'Code postal',
      city: 'Ville',
      state: 'État',
      diastolic: 'Diastolique',
      systolic: 'Systolique',
      time: 'Temps',
      unit: 'Unité',
      timesPer: 'Fois par',
      formPreview: 'Aperçu du formulaire',
      addAnother: 'Ajouter un autre',
    },
  },

  quickFormEditor: {
    configurationFields: {
      isSelectAllEnabled: 'Tout sélectionner',
    },
  },

  alerts: {
    chat: {
      resendInvitationWarn:
        '{patient} will receive the above text message followed by a link. When they click the link they will be redirected to a secure conversation with you.',
      noPhiEmail: 'No PHI here - this will be sent over Email',
      noPhiSms: 'No PHI here - this will be sent over SMS',
      smsInformation:
        'New patient will receive the above text message followed by a link. When they click the link they will be redirected to a secure conversation with you.',
    },

    errors: {
      unexpected: 'Unexpected error happend. Please try again later',
      collectedInfo: 'Impossible de charger les informations collectées',
    },
  },
  videoChat: {
    errors: {
      permissions: {
        title: 'Nous ne pouvons pas vous connecter',
        message: 'Looks like your audio or camera permissions have been denied',
        troubleshoot: 'Troubleshoot',
        clickBelow:
          'Please click "Troubleshoot" button below for a short clip on how to fix your permissions',
      },
      alreadyInUse: {
        title: 'Votre caméra ou microphone est déjà utilisé',
        message:
          'Une autre application utilise peut-être votre caméra ou votre microphone. ' +
          "Si vous êtes sur une sorte d'appel (phone call, Skype, Zoom, GoToMeeting, WebEx, etc), " +
          "ou l'enregistrement à l'aide de votre caméra ou microphone, " +
          "veuillez arrêter l'appel ou l'enregistrement et appuyez sur le bouton X, puis réessayez.",
      },
      deviceMissing: {
        title: "Vous avez besoin d'un microphone et d'une webcam",
        message:
          'Vous ne pouvez pas avoir de chat vidéo sans avoir un microphone et une webcam. ' +
          'Les deux sont nécessaires. ' +
          'Veuillez les connecter et installer les pilotes logiciels éventuellement manquants, ' +
          'puis appuyez sur le bouton X et réessayez',
      },
    },
    refreshPage: 'Refresh page',
    twilioError: {
      genericTitle: 'Twilio service interrupted',
      genericMessage:
        'Service should be up and running shortly, please check back later',
      '53000': {
        title: 'Internal Server Error',
      },
      '20500': {
        title: 'Signaling connection error',
      },
    },
  },
  timeUnits: {
    seconds: 'seconds',
    minutes: 'minutes',
    hours: 'hours',
    days: 'days',
    length: 'A value should contain {count} characters',
    yesterday: 'Yesterday',
    toray: 'Today',
  },
  chooseOptions: 'Choisissez une option',
}
